<div class="data-table-page datatable-page">
  <div class="header-section">
    <elastic-breadcrumbs
      [currentPageTitle]="'ASSET.TITLE' | translate"
      [currentPage]="'NAVIGATION.ASSET' | translate"
      [names]="['NAVIGATION.BUILDING_DATA' | translate]"
      [routes]="['asset']"
      [header]="'primary'"
    >
    </elastic-breadcrumbs>

    <div class="header-buttons u-flex u-row u-jc-start u-ai-center u-gap-20">
      <!-- Grid buttons -->
      <button
        mat-raised-button
        id="grid-columns-filter"
        matTooltip="{{ 'COMMON.COLUMNS' | translate }}"
        color="action"
        type="button"
        (click)="openColumnsPanel(dataGrid)"
      >
        <mat-icon>view_week</mat-icon>
        {{ "COMMON.COLUMNS" | translate }}
      </button>
      <button
        class="create"
        id="{{ 'grid-add' }}"
        type="button"
        color="accent"
        mat-raised-button
        [routerLink]="['/asset/form']"
      >
        <mat-icon>add</mat-icon> {{ "OPERATIONS.NEW" | translate }}
      </button>
      <button
        mat-raised-button
        id="{{ 'grid-export' }}"
        color="action"
        type="button"
        (click)="exportCsv()"
      >
        {{ "ACTIONS.EXPORT" | translate }}
      </button>
    </div>
  </div>

  <bs-data-grid
    #dataGrid
    [gridName]="'assetTable'"
    [columns]="columns"
    [formLink]="['/asset/form']"
    [dataGridService]="dataGridService"
    [dataSource]="dataSource"
    [defaultSort]="{ active: 'assetName', direction: 'asc' }"
  ></bs-data-grid>
</div>
